import * as Const from "../config/const";
import {getLanguage} from "../actions/commands";

export default class Videos {
    constructor(project){
        const language = getLanguage() === 'pt-br'
        this.id = project.vid_id
        this.title = language?project.vid_titulo_pt:project.vid_titulo_en
        this.description = language?project.vid_corpo_pt:project.vid_corpo_en
        this.src = Const.defaults.image_base_url+(language?project.vid_imagem_pt:project.vid_imagem_en)
        this.flag = `${Const.defaults.image_base_url}bandeiras/${(language?project.vid_imagem_pt:project.vid_imagem_en)}`
        this.link = language?project.vid_link_video_pt:project.vid_link_video_en
    }
}


// WEBPACK FOOTER //
// ./src/models/videos.js